import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<boolean> = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0.5rem',
    width: '4rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:nth-child(3)': {
      width: '8rem',
      paddingRight: '4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  status: (isFileFailed) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    justifyContent: 'space-between',
    maxWidth: '8rem',
    cursor: isFileFailed && 'pointer',
  }),
  actionButton: {
    textTransform: 'uppercase',
  },
  tooltip: {
    '& > div': { width: '8rem' },
  },
  errorButton: {
    fontSize: '1.6rem',
    paddingLeft: 0,
    gap: '0.5rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
